import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

const BASE_URL = process.env.VUE_APP_SHOP_V2_BASE_URI
const ARENAS_ENTITY = 'arenas'

export default abstract class ArenaCompanyApi {
  public static baseRoute = `${BASE_URL}/${ARENAS_ENTITY}`

  public static async getCompany(arenaId: string): Promise<AxiosResponse> {
    return await axios.get(`${this.baseRoute}/${arenaId}/company`)
  }

  public static async updateCompany(
    arenaId: string,
    companyId: string,
    data: object,
  ): Promise<AxiosResponse> {
    return await axios.patch(
      `${this.baseRoute}/${arenaId}/companies/${companyId}`,
      data,
    )
  }
}
